import { IMatchReportsDetail, MatchReportsTypings, PlayerTypings, MatchTypings } from "@sky-it-livedata/livedata-sports-design-system";
import { MatchReportsDetailsQuery } from "../types";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { isValidMatchReportsDetails } from "./typeguards";
import { ReportDetailsMatchTeam } from "appsync";

export default (obj: MatchReportsDetailsQuery): IMatchReportsDetail => {
    
    if (isValidMatchReportsDetails(obj)) {

        const { reports, reportsHomepageUrl } = obj.data.getReportDetails;

        const transformTeam = (team: ReportDetailsMatchTeam) => {
            const { fullname: managerName, ..._manager } = team!.playerList!.manager!;
            const startingLineup = team?.playerList?.startingLineup?.map((player: any) => {
                const { fullname: fullName, ...rest } = player;
                return { fullName, ...rest };
            });
            const substitutes = team?.playerList?.substitutes?.map((player: any) => {
                const { fullname: fullName, ...rest } = player;
                return { fullName, ...rest };
            });
            const goal = typeof team?.goal === "number" ? team.goal : undefined;
            return {
                ...team,
                goal,
                playerList: {
                    manager: { fullName: managerName, ..._manager },
                    startingLineup: startingLineup,
                    substitutes: substitutes,
                }
            } as IMatchReportsDetail["matchDayList"][number]["home"] | IMatchReportsDetail["matchDayList"][number]["away"];
        }

        const matchDayList = reports?.map((report) => ({
            ...report,
            away: transformTeam({
                ...(report?.away as any),
                goal: typeof report?.away?.goal === "number" ? report?.away?.goal : undefined,
            } as ReportDetailsMatchTeam),
            home: transformTeam({
                ...(report?.home as any),
                goal: typeof report?.home?.goal === "number" ? report?.home?.goal : undefined,
            } as ReportDetailsMatchTeam),
            date: report?.date || '',
            referees: report?.referees?.filter(Boolean).map((referee) => {
                return {
                    fullName: referee?.fullname,
                    topPlayer: referee?.topPlayer,
                    id: referee?.id,
                    vote: referee?.vote,
                }
            }) as PlayerTypings.IReferee[] | undefined,
            reportStatus: report?.reportStatus as MatchReportsTypings.ReportStatus,
            status: report?.status as MatchTypings.MatchStatusType,
        }));

        return {
            matchDayList: matchDayList || [],
            reportsHomepageUrl: reportsHomepageUrl || undefined,
          };
    } else {
        throw new WidgetError<ErrorName>({
          name: "NO_VALID_DATA",
          message: "Invalid transformer input, Error in MatchReportsDetailsQuery object",
          data: obj,
        });
    }
};